import { Subject } from "rxjs";

import { Injectable, Signal, signal, WritableSignal } from "@angular/core";

@Injectable()
export class SidebarService {
  private readonly customDesktopSidebar: WritableSignal<boolean> =
    signal(false);

  readonly useCustomDesktopSidebar: Signal<boolean> =
    this.customDesktopSidebar.asReadonly();

  readonly mobileSidebarToggleClick$ = new Subject<void>();

  enableCustomDesktopSidebar(): void {
    this.customDesktopSidebar.set(true);
  }

  disableCustomDesktopSidebar(): void {
    this.customDesktopSidebar.set(false);
  }

  notifyMobileToggle(): void {
    this.mobileSidebarToggleClick$.next();
  }
}
